import { render, staticRenderFns } from "./DateRenderer.vue?vue&type=template&id=2dd7e508&scoped=true"
import script from "./DateRenderer.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateRenderer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DateRenderer.vue?vue&type=style&index=0&id=2dd7e508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd7e508",
  null
  
)

export default component.exports